<template>
    <a-spin :tip="loadingTip" :spinning="isloading">
        <div>
            <div class>
                <a-form :form="form" @submit="handleSubmit">
                    <a-form-item label="分类名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                            placeholder="请输入分类名称"
                                            v-decorator="[
                      'name',
                      {rules: [{ required: true, message: '请输入电话!' }],initialValue:info.name}
                    ]"
                                    ></a-input>
                    </a-form-item>
                    <a-form-item
                                        label="分类图片"
                                        :label-col="{ span: 5 }"
                                        :wrapper-col="{ span: 19 }"
                                        class="is-required"
                                >
                                 <a-upload
                                    list-type="picture-card"
                                    class="avatar-uploader"
                                    :show-upload-list="false"
                                    :action="$api.file.uploadFile"
                                    :multiple="false"
                                    :beforeUpload="beforeUpload"
                                    @change="handleChange"
                                  >
                                    <img v-if="info.img"alt="example" style="width: 100%" :src="info.img" />
                                    <div v-else>
                                        <a-icon type="plus"/>
                                        <div class="ant-upload-text">Upload</div>
                                    </div>
                                </a-upload>
                        <p style="color:red;">分类图片比例  5：8</p>
                      </a-form-item>
                      <a-form-item label="文章" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
                        <a-select show-search v-model="info.articleId" :filter-option="filterOption" style="width: 100%" placeholder="请选择文章">
                          <a-select-option :value="item.id"  v-for="item in articleList" :key="item.id">
                            {{item.title}}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                  <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
                    <pxkeji-btn name="保存" type="primary" htmlType="submit"/>
                    <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn"/>
                  </a-form-item>
                </a-form>
            </div>
        </div>
    </a-spin>
</template>

<script>
  var that;
  export default {
      props: {
        infos: {
          default: () => {
          }
        }
      },
      data() {
          return {
            name: "websiteCustomInfo",
              form: this.$form.createForm(this),
              info: {
                index:0,
                name:'',
                img:'',
                articleId:'',
              },
              isloading: false,
              loadingTip: "加载中...",
              articleList:[],
          };
      },
      components: {},
      mounted() {
          this.$nextTick(function () {
            that = this;
            this.getInfo();
            this.getArticleList();
          });
      },
      methods: {
        handleSubmit(e){
          e.preventDefault();
          this.form.validateFields((err, values) => {
            this.info.name=values.name
              this.$emit('callbackMethod',this.info);
          })

        },
          getInfo() {

                this.info = this.infos;
          },
          filterOption(input, option) {
           return (
              option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          },
           getArticleList(){
                 this.isloading = true;
                  this.$api.article
                    .getRecommendList()
                    .then(res => {
                      this.isloading = false;
                      if (res.errorCode == this.$msg.responseCode.success) {
                        this.articleList = res.data;
                      } else {
                        this.error(res.errorMsg);
                      }
                    })
                    .catch(() => {
                      this.isloading = false;
                      this.error();
                    });
            },
          /**取消 */
          cancelClick() {
            this.$emit("callbackMethod");
          },

          beforeUpload(file, fileList) {
            var isJPGPNG = false;
            if (file.type === "image/jpeg" || file.type === "image/png") {
              isJPGPNG = true;
            } else {
              isJPGPNG = false;
              this.$message.error("只能上传jpg/png格式的文件!");
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
              this.$message.error("文件不能超过2MB!");
            }
            return isJPGPNG && isLt2M;
          },
          handleChange(info) {
              if (info.file.status === 'done') {
                  this.info.img=info.file.response.data.path;
                  this.$message.success('文件上传成功');
              } else if (info.file.status === 'error') {
                  this.$message.error('文件上传失败');
              }
          },
          error(msg) {
            this.$error({
              title: "提示",
              content: msg == undefined ? "服务器异常" : msg,
              okText: "返回",
              centered: true,
              onOk() {
                that.$emit("callbackMethod");
              }
            });
          },
      }
  };
</script>
<style>
.avatar-uploader > .ant-upload {
      width: 128px;
      height: 128px;
    }
    .ant-upload-select-picture-card i {
      font-size: 32px;
      color: #999;
    }

    .ant-upload-select-picture-card .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }
</style>